import GuestView from 'modules/guest/view';

export default function GuestPassengerPage() {
  return <GuestView type="default" />;
}
